function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, "\n            .a {\n                fill: url(#a);\n            }\n\n            .b {\n                fill: url(#b);\n            }\n\n            .c {\n                fill: url(#c);\n            }\n\n            .d {\n                fill: #3e2775;\n            }\n\n            .e {\n                fill: url(#d);\n            }\n        "), React.createElement("linearGradient", {
  id: "a",
  x1: 207.88,
  y1: 94.32,
  x2: 207.88,
  y2: 457.13,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0.01,
  stopColor: "#01a0c6"
}), React.createElement("stop", {
  offset: 0.38,
  stopColor: "#075e94"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#055484"
})), React.createElement("linearGradient", {
  id: "b",
  x1: 358.38,
  y1: 457.13,
  x2: 358.38,
  y2: 696.27,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#075e94"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#01a0c6"
})), React.createElement("linearGradient", {
  id: "c",
  x1: 320.98,
  y1: 457.13,
  x2: 320.98,
  y2: 696.27,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#06396b"
}), React.createElement("stop", {
  offset: 0.07,
  stopColor: "#064273"
}), React.createElement("stop", {
  offset: 0.5,
  stopColor: "#0375a0"
}), React.createElement("stop", {
  offset: 0.82,
  stopColor: "#0294bc"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#01a0c6"
})), React.createElement("linearGradient", {
  id: "d",
  x1: 165.08,
  y1: 47.16,
  x2: 231.45,
  y2: 47.16,
  xlinkHref: "#c"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "bg");

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "a",
  d: "M146.16,274.94c21.86,64.89,77.06,123.59,134,182.19-13.2-51.41-33.82-101.51-53.83-150.86-27.7-68.31-55-139-60.27-211.95C136.12,153.35,125.94,214.94,146.16,274.94Z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "b",
  d: "M280.12,457.13c8.18,31.87,13.51,64.24,14.05,97.25.81,49.14-8.84,96.37-25.32,141.89H447.92c-12.44-41.69-33.13-82.62-62.24-121.79C355.78,534.25,317.58,495.71,280.12,457.13Z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "c",
  d: "M242.72,457.13c8.18,31.87,13.51,64.24,14,97.25.81,49.14-8.84,96.37-25.32,141.89H410.52c-12.44-41.69-33.13-82.62-62.24-121.79C318.38,534.25,280.18,495.71,242.72,457.13Z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "d",
  d: "M294.17,554.38c-.54-33-5.87-65.38-14.05-97.25-56.9-58.6-112.1-117.3-134-182.19-20.22-60-10-121.59,19.86-180.62a339.15,339.15,0,0,1-.71-37.48A264.22,264.22,0,0,1,173.83,0H76.05A76.05,76.05,0,0,0,0,76.05V620.23a76,76,0,0,0,76.05,76h192.8C285.33,650.75,295,603.52,294.17,554.38Z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "e",
  d: "M166,94.32C182.46,61.87,204.86,30.2,231.45,0H173.83a264.22,264.22,0,0,0-8.52,56.84A339.15,339.15,0,0,0,166,94.32Z"
});

var SvgBg = function SvgBg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 447.92 696.27",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bg.327a522f.svg";
export { ForwardRef as ReactComponent };